import { cartHeaderStyles } from "@insite/content-library/Widgets/Cart/CartHeader";
import { css } from "styled-components";

cartHeaderStyles.gridItem1 = {
    width: [10, 10, 6, 7, 8],
};

cartHeaderStyles.gridItem2 = {
    width: [2, 2, 6, 5, 4],
};

cartHeaderStyles.approverInfoGridItem = {
    width: 12,
    css: css`
        padding: 0 15px;
    `,
};
